import * as THREE from "three";

export function applyRadiusColor(geometry, topColorHex, bottomColorHex, defaultColorHex, sideColorHex) {
  if (!geometry || !geometry.attributes || !geometry.attributes.position) return;

  // 法線がなければ計算
  if (!geometry.attributes.normal) geometry.computeVertexNormals();

  const posAttr = geometry.attributes.position;
  const normalAttr = geometry.attributes.normal;
  const colors = new Float32Array(posAttr.count * 3);
  const hasTop = topColorHex !== undefined && topColorHex !== null;
  const hasBottom = bottomColorHex !== undefined && bottomColorHex !== null;
  const hasSide = sideColorHex !== undefined && sideColorHex !== null;

  const topColor = new THREE.Color(hasTop ? topColorHex : 0xffffff);
  const bottomColor = new THREE.Color(hasBottom ? bottomColorHex : 0xffffff);
  const defaultColor = new THREE.Color(defaultColorHex !== undefined ? defaultColorHex : 0xdddddd);
  const sideColor = hasSide ? new THREE.Color(sideColorHex) : null;
  const tmp = new THREE.Color();
  // console.log("hasTop:", hasTop, "hasBottom:", hasBottom, "hasSide:", hasSide);

  for (let i = 0; i < posAttr.count; i++) {
    const ny = normalAttr.array[i * 3 + 1];

    // 厳密な振る舞い:
    // - hasTop && !hasBottom: 法線が上向きの頂点のみをtopColorにする（側面は完全にdefaultColor）
    // - hasBottom && !hasTop: 法線が下向きの頂点のみをbottomColorにする（側面は完全にdefaultColor）
    // - hasTop && hasBottom: 上/下/側面それぞれを割り当て（側面はsideColorがあればそれ、なければtopColor）

    const normalThreshold_small = 0.1;
    const normalThreshold_large = 0.9;

    if (hasTop && !hasBottom) {
      if (ny >= normalThreshold_small) tmp.copy(topColor);
      else tmp.copy(defaultColor);
    } else if (hasBottom && !hasTop) {
      if (ny <= -normalThreshold_large) tmp.copy(bottomColor);
      else tmp.copy(defaultColor);
    } else if (hasTop && hasBottom) {
      if (ny >= normalThreshold_large) tmp.copy(topColor);
      else if (ny <= -normalThreshold_large) tmp.copy(bottomColor);
      else {
        if (sideColor) tmp.copy(sideColor);
        else tmp.copy(topColor);
      }
    } else {
      tmp.copy(defaultColor);
    }
    colors[i * 3] = tmp.r;
    colors[i * 3 + 1] = tmp.g;
    colors[i * 3 + 2] = tmp.b;
  }
  geometry.setAttribute("color", new THREE.BufferAttribute(colors, 3));
}

export default applyRadiusColor;
